import { type AnalyticsClient } from '../../utils/analytics';
import type {
	AutoConvertDefinition,
	AutoConvertMacroAttributes,
	AutoConvertMacroAttributesMap,
	AutoConvertMatcherToExtensionsMap,
} from './types';
import { convertLinkToMacroNode } from './utils/convertLinkToMacroNode';

export const createForgeMacroAutoConverter = (
	analyticsClient: AnalyticsClient,
	autoConvertDefinitions?: AutoConvertDefinition[],
	macroADFNodeMap?: AutoConvertMacroAttributesMap,
	autoConvertMatcherToExtensionsMap?: AutoConvertMatcherToExtensionsMap,
): ((link: string) => AutoConvertMacroAttributes | null) => {
	return (link: string) =>
		convertLinkToMacroNode(
			link,
			analyticsClient,
			autoConvertDefinitions,
			macroADFNodeMap,
			autoConvertMatcherToExtensionsMap,
		);
};
